import { PenaltyWarningDialog } from './penalty-warning-dialog';
import { DIALOG, transitions } from 'dialogs';
import { MarketplaceDialogs } from '../../../marketplace-dialogs.config';

DIALOG.add(MarketplaceDialogs.INVENTORY_PENALTY_WARNING_DIALOG, {
  component: PenaltyWarningDialog,
  transition: transitions.SCALABLE,
  anchor: 'marketplace',
});
